import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instanceovl8he3jiijf as Companion_instance,
} from '../collections/AbstractList.mjs';
import { getOrNull1d60i0672n7ns as getOrNull } from '../collections/_Arrays.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function enumEntries(entries) {
  return EnumEntriesList().pp(entries);
}
var EnumEntriesListClass;
function EnumEntriesList() {
  if (EnumEntriesListClass === VOID) {
    class $ extends AbstractList() {
      static pp(entries) {
        var $this = this.ti();
        $this.op_1 = entries;
        return $this;
      }
      p1() {
        return this.op_1.length;
      }
      q1(index) {
        Companion_instance.f7(index, this.op_1.length);
        return this.op_1[index];
      }
      qp(element) {
        if (element === null)
          return false;
        var target = getOrNull(this.op_1, element.b4_1);
        return target === element;
      }
      t1(element) {
        if (!(element instanceof Enum()))
          return false;
        return this.qp(element instanceof Enum() ? element : THROW_CCE());
      }
      rp(element) {
        if (element === null)
          return -1;
        var ordinal = element.b4_1;
        var target = getOrNull(this.op_1, ordinal);
        return target === element ? ordinal : -1;
      }
      s1(element) {
        if (!(element instanceof Enum()))
          return -1;
        return this.rp(element instanceof Enum() ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'EnumEntriesList', VOID, VOID, [KtList(), AbstractList()]);
    EnumEntriesListClass = $;
  }
  return EnumEntriesListClass;
}
//region block: exports
export {
  enumEntries as enumEntries20mr21zbe3az4,
};
//endregion

//# sourceMappingURL=EnumEntries.mjs.map
